export function getSeedtagContext(isDesktop: boolean): object {
	const desktopSlots = {
		leader_plus_top: {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836873',
			placement: 'inBanner',
		},
		leader_top: {
			sizes: [[728, 90]],
			publisherId: '1758-1273-01',
			adUnitId: '29836873',
			placement: 'inBanner',
		},
		mpu_plus_top: {
			sizes: [
				[300, 250],
				[300, 600],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836874',
			placement: 'inArticle',
		},
		mpu_bottom: {
			sizes: [[300, 250]],
			publisherId: '1758-1273-01',
			adUnitId: '29836876',
			placement: 'inArticle',
		},
		leader_bottom: {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836877',
			placement: 'inBanner',
		},
		leader_middle: {
			sizes: [[728, 90]],
			publisherId: '1758-1273-01',
			adUnitId: '29836878',
			placement: 'inBanner',
		},
		leader_middle2: {
			sizes: [[728, 90]],
			publisherId: '1758-1273-01',
			adUnitId: '29836878',
			placement: 'inBanner',
		},
		incontent_plus_top: {
			sizes: [
				[728, 90],
				[970, 250],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836873',
			placement: 'inBanner',
		},
	};

	const mobileSlots = {
		mobile_banner_top: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836873',
			placement: 'inBanner',
		},
		mobile_incontent_plus_top: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836874',
			placement: 'inArticle',
		},
		mobile_banner_plus_middle: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836879',
			placement: 'inArticle',
		},
		mobile_incontent_plus_middle2: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836880',
			placement: 'inArticle',
		},
		mobile_mpu_banner_bottom: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836876',
			placement: 'inArticle',
		},
		mobile_gallery_banner_plus_1: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_2: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_3: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_4: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_5: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_6: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_7: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_8: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_9: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_10: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_11: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_12: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		mobile_gallery_banner_plus_13: {
			sizes: [
				[300, 250],
				[320, 50],
			],
			publisherId: '1758-1273-01',
			adUnitId: '29836886',
			placement: 'inBanner',
		},
		'mobile-nav-ad-plus-banner': {
			sizes: [[320, 50]],
			publisherId: '1758-1273-01',
			adUnitId: '29836888',
			placement: 'inScreen',
		},
	};

	return {
		enabled: false,
		slots: isDesktop ? desktopSlots : mobileSlots,
	};
}
